import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Hamburger = ({ active, className }) => {
  return (
    <div
      className={classNames(
        'Hamburger',
        'Hamburger--spin',
        { 'is-active': active },
        className
      )}
    >
      <div className="Hamburger__box">
        <div className="Hamburger__inner" />
      </div>
    </div>
  );
}

Hamburger.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool
};

Hamburger.defaultProps = {
  className: ''
};

export default Hamburger;
